<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const snippet = `
    <footer class="small-footer">
      <div class="small-footer-container">
        <div class="flex flex-col md:flex-row-reverse gap-4 items-stretch md:items-center md:justify-between">
          <div>
            <a class="small-footer-phone-link" href="tel:131642">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                class="inline pr-1"
                viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                  <path d="M0 0h24v24H0z" />
                  <path
                    d="M14.732 22.972l.012.006c2.44 1.555 5.664 1.2
                    7.73-.865l.768-.767a2.58 2.58 0 000-3.646l-3.232-3.23a2.58
                    2.58 0 00-3.646 0 1.077 1.077 0 01-1.524 0L9.67 9.298a1.08
                    1.08 0 010-1.525 2.576 2.576 0 000-3.645L6.439.894A2.58 2.58
                    0 002.792.893l-.767.767a6.235 6.235 0 00-.852
                    7.755l.017.026a50.241 50.241 0 0013.5 13.504l.042.027zM2.436
                    8.605l-.006-.008a4.731 4.731 0 01.656-5.876l.767-.767a1.08
                    1.08 0 011.525 0l3.23 3.234a1.077 1.077 0 010 1.524 2.58
                    2.58 0 000 3.646l5.171 5.172a2.576 2.576 0 003.646 0 1.08
                    1.08 0 011.525 0l3.231 3.23a1.08 1.08 0 010
                    1.525l-.767.767a4.733 4.733 0 01-5.889.646l-.01-.006A48.735
                    48.735 0 012.435 8.605z"
                    class="fill-current" />
                </g>
              </svg>
              <span>13 16 42</span>
            </a>
          </div>
          <div class="flex flex-col flex-wrap md:flex-row md:justify-between md:w-full gap-4">
            <div>
              Copyright
              <span>&copy;</span>
              2022 nib health funds limited ABN 83 000 124 381
            </div>
            <nav class="inline-flex flex-col md:flex-row gap-2">
              <a class="link link-light" href=".">Fund Rules</a>
              <a class="link link-light" href=".">Terms & Conditions</a>
              <a class="link link-light" href=".">Privacy Policy</a>
              <a class="link link-light" href=".">Code of Conduct</a>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  `;
</script>

<template>
  <section id="small-footer" class="page-section bg-sageGreen40">
    <div class="container">
      <h2 class="heading heading-2 my-6">Small Footer</h2>
    </div>
    {@html snippet}
    <div class="container">
      <CodeSnippet id="small-footer" {snippet} />
    </div>
  </section>
</template>
